import React, { memo } from 'react';
import { Switch, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import RouterRoute from './RouterRoute';
import { RouterContext } from './context';

function RouterSwitch({
  rootPath = '/',
  rootAccessPath = [],
  rootComponent = null,
  children = null
}) {
  return (
    <RouterContext.Provider value={{ rootPath, rootAccessPath }}>
      <Switch>
        {children}
        <RouterRoute exact path={rootPath} component={rootComponent} />
        <Redirect to={rootPath} />
      </Switch>
    </RouterContext.Provider>
  );
}

export default memo(RouterSwitch, (prevProps, nextProps) => {
  const prevAccessPaths = _get(prevProps, 'rootAccessPath', []);
  const nextAccessPaths = _get(nextProps, 'rootAccessPath', []);
  return (
    prevProps.rootPath === nextProps.rootPath &&
    prevProps.children === nextProps.children &&
    prevProps.rootComponent === nextProps.rootComponent &&
    prevAccessPaths.join('.') === nextAccessPaths.join('.')
  );
});
